/**
 * Course Header Images Configuration
 * High-quality HD images for course headers featuring American Black men
 */

export const COURSE_IMAGES = {
  'digital-identity': {
    header: 'https://images.unsplash.com/photo-1660742533971-eb413acbfb47?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    thumbnail: 'https://images.unsplash.com/photo-1660742533971-eb413acbfb47?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    alt: 'Black man digital tech professional'
  },
  'biblical-wealth': {
    header: 'https://images.unsplash.com/photo-1758519290890-46b542bb25fd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    thumbnail: 'https://images.unsplash.com/photo-1758519290890-46b542bb25fd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    alt: 'Black businessman wealth finance'
  },
  'business-mastery': {
    header: 'https://images.unsplash.com/photo-1669034750695-dfe5cad91d6d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    thumbnail: 'https://images.unsplash.com/photo-1669034750695-dfe5cad91d6d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    alt: 'Black entrepreneur business success'
  },
  'real-estate-investing': {
    header: 'https://images.unsplash.com/photo-1644740201523-d06231d53379?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    thumbnail: 'https://images.unsplash.com/photo-1644740201523-d06231d53379?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    alt: 'Black man real estate property'
  },
  'family-leadership': {
    header: 'https://images.unsplash.com/photo-1621973133111-63649acea55a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    thumbnail: 'https://images.unsplash.com/photo-1621973133111-63649acea55a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    alt: 'Black man leadership family'
  },
  'investing-foundations': {
    header: 'https://images.unsplash.com/photo-1554913766-a48657e1e51c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    thumbnail: 'https://images.unsplash.com/photo-1554913766-a48657e1e51c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    alt: 'Black man investing finance'
  },
  // Default fallback
  default: {
    header: 'https://images.unsplash.com/photo-1612299273045-362a39972259?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1920',
    thumbnail: 'https://images.unsplash.com/photo-1612299273045-362a39972259?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    alt: 'Black man professional'
  }
};

// Module icons for visual enhancement
export const MODULE_ICONS = {
  video: '🎬',
  text: '📖',
  quiz: '✓',
  assignment: '📝',
  download: '📥'
};

// Get course image or fallback to default
export const getCourseImage = (courseId) => {
  return COURSE_IMAGES[courseId] || COURSE_IMAGES.default;
};
